angular.module('natgeo').directive('menuButton', function()
{
  var controller = ['$scope', 'SoundEngine', 'UserProgress', 'ScreenView', '$element', 'container', 'screenManager',
  function MenuButton($scope, SoundEngine, UserProgress, ScreenView, element, container, screenManager)
  {
    // Muting Functionality
    $scope.isMute = SoundEngine.isMute;
    $scope.mute   = SoundEngine.mute;
    $scope.unmute = SoundEngine.unmute;

    // Show the credit screen.
    $scope.credits = function()
    {
      var dialog = element.find( '.credits-dialog' );

      dialog.play( 'fadeIn 0.5s' );
      dialog.applyInitialState();
      dialog.removeClass('hidden');
      dialog.find('credits').trigger('ready');
      dialog.find('[data-show]').hide();
      dialog.css('zIndex', 1000);
      dialog.animators().once('finished', function()
      {
        dialog.find('[data-show]')
          .show()
          .restore()
          .dataPlay('show')
          .applyInitialState()
        ;

      });

      // Set the hash so they can save the URL
      window.location.hash = '#credits';
    };

    // Closes the credit screen.
    $scope.closeCredits = function()
    {
      var dialog = element.find( '.credits-dialog' );

      dialog.play( 'fadeOut 0.5s' );
      dialog.applyInitialState();
      dialog.animators().once('finished', function()
      {
        dialog.addClass('hidden');
      });

      // Reset the hash
      window.location.hash = '#';
    };

    // Show the menu popup
    $scope.showMenu = function()
    {
      var dialog = element.find( '.menu-dialog' );
      
      dialog.play( 'fadeIn 0.5s' );
      dialog.applyInitialState();
      dialog.removeClass('hidden');
      dialog.find('[data-show]').hide();
      dialog.animators().once('finished', function()
      {
        dialog.find('[data-show]')
          .show()
          .restore()
          .dataPlay('show')
          .applyInitialState()
        ;
      });

      SoundEngine.play( 'show-menu' );
    };

    // Close the menu popup
    $scope.closeMenu = function()
    {
      var dialog = element.find( '.menu-dialog' );

      dialog.play( 'fadeOut 0.5s' );
      dialog.applyInitialState();
      dialog.animators().once('finished', function()
      {
        dialog.addClass('hidden');
      });
    };

    // Shows the passcode for the current progress
    $scope.getPasscode = UserProgress.getPasscode;

    // Exits to the main Menu
    $scope.exit = function()
    {
      var dialog = element.find( '.menu-dialog' );

      dialog.play( 'fadeOut 0.3s' );
      dialog.applyInitialState();
      dialog.animators().once('finished', function()
      {
        dialog.addClass('hidden');

        // This will let any extensive game playing know to cancel.
        anim8.animating.stop();
        screenManager.current.CANCEL = true;

        // Stop all sounds
        SoundEngine.stopAll();

        ScreenView.change( 'splash', 'splash_menu', true, undefined, 'loading_menu' );
      });
    };

    // Build the elements!
    ScreenView.build( element );

    // Scale the elements!
    element.find('*').scale( container.getScale() );

  }];

  return {
    templateUrl: 'templates/menu-button.html',
    restrict: 'E',
    controller: controller
  };
})